import ImgIcon, { ImgIconProps } from '../ImgIcon/ImgIcon';

export interface TableCheckedCenterIconProps extends Omit<ImgIconProps, 'src' | 'alt'> {}

export default function TableCheckedCenterIcon(props: TableCheckedCenterIconProps) {
  return (
    <ImgIcon src="/images/ai_assistant/icon-table-checked-center.svg" alt="dbt icon" size={props.size} />
  );
}
